import { Host, ApiAuth } from './config'

import axios from 'axios'
import iView from 'view-design'
import { getToken } from './tools'
import router from '@/router/index'
import store from '@/store/index'

export const baseUrl = (process.env.NODE_ENV === 'development' ? Host.dev : Host.pro)

class HttpRequest {
  constructor (baseUrl) {
    this.baseUrl = baseUrl
    this.lastRateLimitMessageAt = 0
    this.redirectingToLogin = false
  }

  handleLoginRequired () {
    store.commit('logout')
    if (this.redirectingToLogin || router.currentRoute.name === 'login') return
    this.redirectingToLogin = true
    const finish = () => { this.redirectingToLogin = false }
    router.replace({
      name: 'login',
      query: { redirect: router.currentRoute.fullPath }
    }, finish, finish)
  }

  showRateLimitMessage () {
    const now = Date.now()
    if (now - this.lastRateLimitMessageAt < 3000) return
    this.lastRateLimitMessageAt = now
    iView.Message.warning('请求过于频繁，请稍后再试')
  }

  interceptors (instance) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      const { data, status } = res
      if (Number(data.code) === -996) {
        this.handleLoginRequired()
        throw new Error(data.msg || '请先登录')
      }
      if (data.code < 0) {
        if (!(res.config && res.config.silentError)) iView.Message.error(data.msg)
        throw new Error(data.msg)
      } else {
        return { data, status }
      }
    }, error => {
      if (error && error.response && Number((error.response.data || {}).code) === -996) {
        this.handleLoginRequired()
        return Promise.reject(error)
      }
      if (error && error.config && error.config.silentError) return Promise.reject(error)
      if (error && error.response && error.response.status === 429) {
        this.showRateLimitMessage()
      } else if (!error.response) {
        iView.Message.error('网络请求失败，请检查接口证书或网络连接')
      }
      return Promise.reject(error)
    })
  }

  request (options) {
    const instance = axios.create()
    let token = getToken()
    if (token === false || !token) {
      options = Object.assign({
        baseURL: this.baseUrl,
        headers: {
          ApiAuth: ApiAuth
        }
      }, options)
    } else {
      options = Object.assign({
        baseURL: this.baseUrl,
        headers: {
          ApiAuth: token
        }
      }, options)
    }
    this.interceptors(instance)
    return instance(options)
  }
}

const api_axios = new HttpRequest(baseUrl)
export default api_axios
